import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["hasChanges", "sets", "onChangeSets"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import filterObject from 'utils/filterObject';
import createLocation from 'utils/createLocation';
import toArray from 'utils/toArray';
import { SKILL_ROUTES } from 'utils/routes';
import FormField from 'components/FormField';
import Button from 'components/Button';
import ShadedListItem from 'components/ShadedListItem';
import Stack from 'components/Stack';
import UnsavedChangesModal from 'screens/UnsavedChangesModal';
import SkillSetPickerModal from 'screens/SkillSetPickerModal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
function SetsField(_ref) {
  var hasChanges = _ref.hasChanges,
    sets = _ref.sets,
    onChangeSets = _ref.onChangeSets,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var navigate = useNavigate();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pendingSetId = _useState2[0],
    setPendingSetId = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasSetsPickerModal = _useState4[0],
    setHasSetsPickerModal = _useState4[1];
  function navigateToSet(setId) {
    navigate(createLocation(SKILL_ROUTES.root, filterObject({
      tab: 'sets',
      setsSelection: [setId]
    })));
  }
  function onEditSet(setId) {
    if (hasChanges) {
      setPendingSetId(setId);
    } else {
      navigateToSet(setId);
    }
  }
  function onDiscardChanges() {
    if (pendingSetId) {
      navigateToSet(pendingSetId);
      setPendingSetId(null);
    }
  }
  function onRemoveSet(setId) {
    var setsToRemove = sets.filter(function (item) {
      return item.id === setId;
    });
    if (setsToRemove) {
      onChangeSets({
        toRemove: setsToRemove
      });
    }
  }
  function onSubmitSets(_ref2) {
    var toAdd = _ref2.toAdd,
      toRemove = _ref2.toRemove;
    onChangeSets({
      toAdd: toArray(toAdd),
      toRemove: toArray(toRemove)
    });
    setHasSetsPickerModal(false);
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormField, _objectSpread(_objectSpread({
      as: "fieldset",
      label: t('content_type_set_plural')
    }, otherProps), {}, {
      children: /*#__PURE__*/_jsxs(Stack, {
        spacing: "xs",
        children: [_toConsumableArray(sets).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        }).map(function (item) {
          return /*#__PURE__*/_jsx(ShadedListItem, {
            id: item.id,
            title: item.name,
            onEdit: onEditSet,
            onRemove: onRemoveSet
          }, item.id);
        }), /*#__PURE__*/_jsx(Button, {
          icon: "plus",
          onClick: function onClick() {
            return setHasSetsPickerModal(true);
          },
          size: "medium",
          children: t('actions_add_to_sets')
        })]
      })
    })), pendingSetId && /*#__PURE__*/_jsx(UnsavedChangesModal, {
      canSaveChanges: false,
      onDiscardChanges: onDiscardChanges,
      onClose: function onClose() {
        return setPendingSetId(null);
      }
    }), hasSetsPickerModal && /*#__PURE__*/_jsx(SkillSetPickerModal, {
      onClose: function onClose() {
        return setHasSetsPickerModal(false);
      },
      onSubmit: onSubmitSets,
      defaultSelectedItems: sets
    })]
  });
}
export default SetsField;